import { AxiosResponse } from 'axios';
import fileDownload from 'js-file-download';

export const responseDownload = (response: AxiosResponse<Blob>) =>
  fileDownload(response.data, response.headers['content-disposition'].split('filename=')[1]);
